export default "__VITE_ASSET__04817f11__"